import React, {Component} from 'react'
import {Query} from 'react-apollo'
import gql from 'graphql-tag'

import ProjectBudgetSelection from "./ProjectBudgetSelection";

const QUERY = gql`query project_activity_budget($project_activity_budget_id: Int!){
  project_activity_budget(project_activity_budget_id: $project_activity_budget_id){
    id
    project{
      project_id
      name
      project_activity_budgets{
        id
        description
        stage
        project_activity_type_id
        project_activity_type{
          project_activity_type_id
          description
        }
        address{
          full_address
        }
        breakdown{
          id
          description
        }
      }
    }
  }
}`

export default class ProjectBudgetSelectionEdit extends Component{

    render(){


        return (
            <Query query={QUERY} variables={{project_activity_budget_id: this.props.value}} skip={!this.props.value}>
                {({loading, error, data}) => {
                    console.log(data)
                    if(loading) return <p>Loading...</p>
                    if(error) return <p>Error: {error}</p>
                    return (
                        <ProjectBudgetSelection
                            onChange={this.props.onChange}
                            project={data && data.project_activity_budget && data.project_activity_budget.project}
                            selectedBudgetId={data && data.project_activity_budget && data.project_activity_budget.id}
                        />
                    )
                }}
            </Query>

        )
    }

}